module.exports = "<p >\n  <i class=\"fa fa-ban fa-5x\"></i>\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/no-access/no-access.component.html
// module id = ./src/app/components/no-access/no-access.component.html
// module chunks = main